import React from "react"
import {Col, Row} from "react-bootstrap"
import {Link} from "react-router-dom";
import logoFooter3 from "Assets/images/footer-img-3.png";
import logoSanseWhite from "Assets/images/logo-sanse-white.png";
import lema from "Assets/images/Lema_RRSS_blanco-300x130.png";
import gobEsp from "Assets/images/gobierno-esp.png";
import corresponsales from "Assets/images/corresponsales.png";
import comMadrid from "Assets/images/com_madrid.png";
import comMadridUni from "Assets/images/com_madrid_uni.png";

import gob600 from "Assets/images/gob-600.jpg";
import {PrivacyPolicyLink} from "Components/Link/PrivacyPolicyLink";
import {LegalWarningLink} from "Components/Link/LegalWarningLink";
import {DataProtectionLink} from "../../Components/Link/DataProtectionLink";

export const Footer: React.FC = () => {

    return (
        <Row id={"footer"}>
            <Col className={"col-12 col-md-10 mx-auto"}>
                <Row>
                    <Col className={"col-12 col-sm-6 col-lg-6 mx-auto"}>
                        <span className={"heading"}>{process.env.REACT_APP_SITE_NAME}</span>
                        <br/>
                        <LegalWarningLink/>&nbsp;·&nbsp;<PrivacyPolicyLink/>
                    </Col>
                    <Col className={"col-12 col-sm-6 col-lg-6 mx-auto"}>
                        <span className={"heading"}>Contacto</span>
                        <span>Si necesitan ponerse en contacto con nosotros para cualquier aclaración o duda se pueden dirigir a nosotros en:</span>
                        <span>C/ Isla de la Palma, 20. 28703 San Sebastián de los Reyes (Madrid)</span>
                        <span>Tel.:
                            &nbsp;<a href={"tel:916638837"}>91 663 88 37</a> -
                            &nbsp;<a href={"tel:670458770"}>670 458 770</a>
                        </span>
                        <span>Email: <a href="mailto:culturalactex@culturalactex.com">culturalactex@culturalactex.com</a></span>
                    </Col>
                </Row>

            </Col>
        </Row>
    )
}
